import { IAjaxCreationMethod } from '@microsoft/portal-app/lib/auth';
import { addAjaxEpic } from '@microsoft/portal-app/lib/redux/createAjaxEpic';
import { IRootUserState } from '@microsoft/portal-app/lib/User/models';
import { setContactMergeSuggestionsSettingsRequest } from '../../../redux/modules/graphApis';
import { IPrivacyAction } from '../../models/IPrivacyActions';
import { IPrivacyState } from '../../models/IPrivacyState';
import { PrivacyActions } from '../../models/PrivacyActions';
import { privacyRegistry as registry } from '../privacyRegistry';

export const setEnableContactsStatusResponse = (state: IPrivacyState, action: IPrivacyAction<unknown>): IPrivacyState => {
  const isEnabled = action.type === `${PrivacyActions.enableContactMergeSuggestions}/success`;
  const nextState: IPrivacyState = {
    ...state,
    contactMergeSuggestionsState: isEnabled
  };

  return nextState;
};

export const setContactMergeSuggestionsStatusFailed = (state: IPrivacyState): IPrivacyState => {
  return state;
};

export const setContactMergeSuggestions =
  (isEnabled: boolean) => (ajax: IAjaxCreationMethod, _action: IPrivacyAction, _state: IRootUserState) => {
    return ajax(setContactMergeSuggestionsSettingsRequest({ isEnabled })).pipe();
};

addAjaxEpic(registry, PrivacyActions.enableContactMergeSuggestions, setContactMergeSuggestions(true), {
  statePropertyName: 'contactMergeSuggestionsState',
  loadingFailedReducer: setContactMergeSuggestionsStatusFailed,
  loadingSuccessReducer: setEnableContactsStatusResponse,
});

addAjaxEpic(registry, PrivacyActions.disableContactMergeSuggestions, setContactMergeSuggestions(false), {
  statePropertyName: 'contactMergeSuggestionsState',
  loadingFailedReducer: setContactMergeSuggestionsStatusFailed,
  loadingSuccessReducer: setEnableContactsStatusResponse,
});
